import PropTypes from 'prop-types';
import Portal from 'react-portal';


const fixedStyle = {
  position: 'fixed',
};

export default function FixedInIFrame({ children, className, style }) {
  return (
    <Portal isOpened
            role="presentation">
      <div style={_.assign({}, style, fixedStyle)}
           className={className}
           role="presentation">
        {children}
      </div>
    </Portal>
  );
}

FixedInIFrame.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  style: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/mobile-overlay/components/fixed-in-iframe/fixed-in-iframe.js